<div class="UNFAPP-tstreprt-full-area SC-GFTCPN-mwrpadb">
    <div class="container">

        <div class="row">
            <div class="col-md-12">
                <div class="UNFAPP-asmnt-tp-hdractn-area test-reprt-pgacnt-hdr">
                    <div>
                        <button type="button" class="btn btn-outline-secondary desk-back-btn" (click)="back()"><img
                                src="assets/img/back-arrow-icon-dark.svg" class="assessment_ml-0"> BACK</button>
                        <button type="button" class="btn mobile-back-btn"><img src="assets/img/mob-back-arrow.png"
                                class="assessment_ml-0" (click)="back()"> Report</button>
                    </div>
                    <div>
                        <!-- <button class="btn UNFAPP-asmnt-blue-hdrbtn"  (click)="openViewSolutionDialog()">VIEW SOLUTION</button> -->
                        <!-- <button class="btn UNFAPP-asmnt-blue-hdrbtn" (click)="viewSolutions()">VIEW SOLUTIONS</button> -->

                        <button class="UNFAPP-blue-txt-link download-certificate-btn desk-view" (click)="downloadScoreCertificate()" *ngIf="examinfo?.examtype == 'SCOREAWAT' ">Completion Certificate</button>
                     <ng-container *ngIf="testResultUtility.overallpaperSelected">
                        <ng-container *ngIf="isTimeBoundTest;else notTimeBoundSolution">
                            <button *ngIf="viewSolutionAvailableTimebound" class="btn UNFAPP-asmnt-blue-hdrbtn" (click)="viewSolutions()" >VIEW SOLUTIONS</button>
                            <button *ngIf="!viewSolutionAvailableTimebound" class="btn UNFAPP-asmnt-blue-hdrbtn btn-disabled-opac" (click)="viewSolutionsComingSoon()">VIEW SOLUTIONS</button>
                        </ng-container>
                        <ng-template #notTimeBoundSolution>
                            <button class="btn UNFAPP-asmnt-blue-hdrbtn" (click)="viewSolutions()">VIEW SOLUTIONS</button>
                        </ng-template>
                    </ng-container>
                    </div> 
                </div>
            </div>
        </div>

        

        
        

        <div class="row">
            <div class="col-md-12">
                <div class="UNFAPP-asmnt-hdng-area livcls-main-hdng mob-col-view _UNFAPP-cmn-mob-hide">
                    <!-- <h3 class="UNFAPP-hdng">{{ testReport?.testname }} | 24 Jun 2021</h3> -->
                    <h3 class="UNFAPP-hdng UNFAPP-main-hdng">{{ testReport?.testname }} <ng-container *ngIf="showEqualiser"> | {{testReport?.timeFormat |date:'dd MMM YYYY'}}</ng-container></h3>
                    <div class="UNFAPP-mob-download-certificate">
                        <button class="UNFAPP-blue-txt-link download-certificate-btn" (click)="downloadScoreCertificate()" *ngIf="examinfo?.examtype == 'SCOREAWAT' ">Completion Certificate <img src="assets/img/play-btn-icon.svg" class="icn" /></button>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="row mob-revers-row" [ngClass]="{'desk-revers-row-for-score': (examinfo?.examtype == 'SCOREAWAT' ||(examinfo?.examtype == 'SCOREMOCKTEST' || examinfo?.examtype == 'SCORE23MOCKTEST'))}" *ngIf="!showEqualiser">
            <div class="col-md-12">
                <div class="UNFAPP-statbx-lstarea">
                    <div class="row">
                        <div class="col-lg-3">
                            <div class="UNFAPP-statbx-bx">
                                <div class="UNFAPP-statbx-icon-info">
                                    <img src="assets/img/goal-lg-icon.svg" alt="" />
                                    <div>
                                        <h3 class="UNFAPP-icnhdng">Total Time Taken</h3>
                                        <h4 class="UNFAPP-cunt UNFAPP-elips">{{ testReport?.totaltimespentinhrs }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-lg-3" *ngIf="examinfo?.examtype == 'SCOREAWAT' ">
                            <div class="UNFAPP-statbx-bx">
                                <div class="UNFAPP-statbx-icon-info UNFAPP-statbx-txt">
                                    <img  src="assets/img/rank-score.svg" alt="Tests Attempted" />
                                    Rank will be visible after SCORE Round 1
                                </div>
                            </div>
                        </div> -->
                        <ng-container *ngIf="isTimeBoundTest">
                            <div class="col-md-6">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 mob-no-gap"
                                        [ngClass]="!testReport.rank && examinfo?.examtype == 'SCOREAWAT' ? 'col' :'col'">
                                        <div class="UNFAPP-statbx-bx mob-view">
                                            <div class="UNFAPP-statbx-icon-info"
                                                [ngClass]="{'normal':(!testReport.rank && examinfo?.examtype == 'SCOREAWAT')}">
                                                <!-- <img src="assets/img/registration/streak-icon.svg" alt="" /> -->
                                                <img src="assets/img/assessment/streak-icon.svg" alt="" />
                                                <div>
                                                    <h3 class="UNFAPP-icnhdng"
                                                        [ngClass]="{'red-text normal':(!testReport.rank && examinfo?.examtype == 'SCOREAWAT')}">
                                                        {{(!testReport.rank && examinfo?.examtype == 'SCOREAWAT' )? 'Rank will be visible after SCORE Round
                                                        1':'Rank'}}</h3>
                                                    <h4 class="UNFAPP-cunt UNFAPP-elips" *ngIf="!(!testReport.rank && examinfo?.examtype == 'SCOREAWAT')">
                                                        {{testReport.rank?testReport.rank:'NA'}}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col mob-no-gap" *ngIf="examinfo.examtype != 'SCOREAWAT'">
                                        <div class="UNFAPP-statbx-bx mob-view">
                                            <div class="UNFAPP-statbx-icon-info">
                                                <img src="assets/img/percentage-with-bg-icon.svg" alt="" />
                                                <div>
                                                    <h3 class="UNFAPP-icnhdng">Percentile</h3>
                                                    <h4 class="UNFAPP-cunt UNFAPP-elips">{{testReport.percentile?(testReport.percentile| number:
                                                        "1.0-1"):'NA'}}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="UNFAPP-score-box">
                    <div class="UNFAPP-score-hdng-area">
                        <span class="score-txt">Your Score</span><span class="score-prize"><b>{{testReport?.totalScore}}</b> /{{testReport?.outOfScore}}</span>
                    </div>
                    <div class="scr-sldr-area">
                        <!-- <mat-progress-bar class="UNFAPP-score-prgbar" mode="determinate" [value]="(testReport?.totalScore/testReport?.outOfScore)*100"></mat-progress-bar> -->


                        <div class="new-custom-progress-bar">
                            <div [style.width]="
                                          (( testReport.totalScore /testReport.outOfScore)*100) + '%'
                                        " class="new-your-score-bar">
                                <!-- <div class="new-y-score">
                                    <span class="new-text">Your Score</span>
                                    <div class="new-sys-img">
                                        <img class="new-icon new-score-bar-profile-image" *ngIf="user?.profilePhoto=== null"
                                            src="assets/img/empty-profile.svg" alt="">
                                        <img class="new-icon new-score-bar-profile-image" *ngIf="user?.profilePhoto!=null" [src]="user?.profilePhoto"
                                            alt="">
                                        <img class="icon" src="assets/img/your-score-icon.svg" alt="" />
                                    </div>
                                </div> -->
                                <!-- <span class="new-score">{{
                                    (testReport.totalScore)| number: "1.0-2"
                                    }}</span> -->
                            </div>
                            <div [style.width]="(averageScore / (testReport.outOfScore)) * 100 + '%'" class="new-avg-score-bar">
                                <div class="new-y-score">
                                    <span class="new-text">Average Score ({{ averageScore | number: "1.0-2" }})</span>
                                    <!-- <img class="new-icon" src="assets/img/avg-scorebar-icon.svg" alt="" /> -->
                                </div>
                                <!-- <span class="new-score">{{ averageScore | number: "1.0-2" }}</span> -->
                            </div>
                            <div *ngIf="testReport?.coursetype!='SCOREAWAT' && testReport?.examtype !== '67521' && testReport?.coursetype !== 'SCOREMOCKTEST' " [style.width]="(100 - ((( testReport.totalScore /testReport.outOfScore)*100) + ((averageScore / (testReport.outOfScore)) * 100)))+'%'" class="new-cutoff-score-bar">
                                <!-- <div class="new-y-score">
                                    <span class="new-text">{{ testReport.testname }} Cutoff</span>
                                    <img class="new-icon" src="assets/img/cutoff-score-icon.svg" alt="" />
                                </div> -->
                                <span class="new-score" *ngIf="testReport?.examtype !== '67521'">{{ testReport.testname }} Cutoff ({{ cutOffScore | number: "1.0-2" }})<img src="assets/img/target-red-icon.svg" class="trgt-icon" /></span>
                            </div>
                            <!-- <span class="new-start-score">0</span>
                            <span class="new-total-score">{{ (testReport.outOfScore) }}</span> -->
                        </div>
                    </div>

                    <div class="mob-scrob-prgrs-stat">
                        <div class="mob-scrob-col"  *ngIf="testReport?.examtype !== '67521'">Average Score<br>({{ averageScore | number: "1.0-2" }})</div>
                        <div class="mob-scrob-col red"  *ngIf="testReport?.examtype !== '67521'">{{ testReport.testname }} Cutoff<br>({{ cutOffScore | number: "1.0-2" }})</div>
                    </div>

                </div>
            </div>
        </div>
        <app-overallpaper [examinfo]="examinfo" *ngIf="paperReady" (paperChangeEvent)="paperChange($event)"></app-overallpaper>
        <div class="row" *ngIf="showEqualiser">
            <div class="col-md-12">
                <h3 class="UNFAPP-tstreprt-sctn-hdng">IL Test Equalizer</h3>
                <div class="UNFAPP-score-whitetbx UNFAPP-equalizer-box">
                    <app-stackedbarchart [testReport]="testReport" [examinfo]="examinfo" [examRanges]="examRanges"> </app-stackedbarchart>
                </div>  
               
            </div>
        </div>

        <div class="row" *ngIf="showEqualiser">
            <div class="col-md-12">
                <app-label [testReport]="testReport"></app-label>
                <!-- <div class="UNFAPP-score-whitetbx UNFAPP-equalizer-box">
                    
                </div>  
                -->
            </div>
        </div>
        
        <div class="row" *ngIf="showEqualiser && testResultUtilityObject.showScoreRace">
            <div class="col-md-12">
                <h3 class="UNFAPP-tstreprt-sctn-hdng">Score</h3>
                <app-scorerace [testRecord] ="testReport" class="UNFAPP-score-rank-graph"></app-scorerace>
            </div>
        </div>
        <div class="row" *ngIf="!showEqualiser">
            <div class="col-md-12">
                <h3 class="UNFAPP-tstreprt-sctn-hdng">Overall Stats</h3>
            </div>
        </div>
        <div class="row" *ngIf="!showEqualiser">
            <div class="col-md-12">
                <div class="UNFAPP-score-whitetbx UNFAPP-score-statbx">
                    <div class="UNFAPP-statbx">
                        <div class="UNFAPP-statbx-icon-info mob-vew">
                            <img src="assets/img/accuracy-yellow-icon.svg" alt="" />
                            <div>
                                <h3 class="UNFAPP-icnhdng">Accuracy
                                    <div class="UNFAPP-c-tooltip"><img src="assets/img/tooltip-info-icon.svg" />
                                        <div class="UNFAPP-c-tooltip-box accuracy">
                                           <div class="UNFAPP-acurcy-toltip-innr">
                                               <div class="UNFAPP-acry-txt">Accuracy = </div>
                                               <div>
                                                <div class="UNFAPP-acry-txt">No. of correct answers</div>
                                                <hr>
                                                <div class="UNFAPP-acry-txt">No. of attempted questions</div>
                                               </div>
                                           </div>
                                        </div>
                                    </div>
                                </h3>
                                <h4 class="UNFAPP-cunt">{{((isnan(testReport?.accuracy) || !testReport?.accuracy) ? 0 : testReport?.accuracy) | number : '1.0-2'}}%</h4>
                            </div>
                        </div>
                    </div>
                    <div class="UNFAPP-statbx">
                        <div class="UNFAPP-statbx-icon-info mob-vew">
                            <img src="assets/img/yellow-clock-md-icon.svg" alt="" />
                            <div>
                                <h3 class="UNFAPP-icnhdng">
                                    <span class="UNFAPP-cmn-mob-hide">Avg. time per question</span>
                                    <span class="UNFAPP-cmn-desk-hide">Avg. time / question</span>
                                </h3>
                                <!-- <h4 class="UNFAPP-cunt">{{getTimeDetails(testReport.averageTimePerQuestion)}}</h4> -->
                                <h4 class="UNFAPP-cunt"> {{testReport?.averageTimePerQuestion}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="UNFAPP-statbx" *ngIf="enableBestSubjectChanges ? testReport?.testSubjects?.length > 1 && testReport?.bestSubject : testReport?.testSubjects?.length > 1"> 
                        <div class="UNFAPP-statbx-icon-info">
                            <img src="assets/img/best-chapter-yellow-icon.svg" alt="" />
                            <div>
                                <h3 class="UNFAPP-icnhdng">Best Subjects</h3>
                                <h4 class="UNFAPP-cunt UNFAPP-elips">{{testReport?.bestSubject}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="UNFAPP-statbx" *ngIf="enableBestSubjectChanges ? (testReport?.testSubjects?.length > 1 && testReport?.scopeOfImprovement) || (bestSubjectChapters?.chapters?.length > 1 && testReport?.testSubjects?.length == 1 && testReport?.bestChapter) : true">
                        <div class="UNFAPP-statbx-icon-info">
                            <!-- <img src="assets/img/emoji-sad-yellow-icon.svg" alt=""  *ngIf="testReport?.testSubjects?.length && testReport?.bestChapter"> -->
                            <img src="assets/img/emoji-sad-yellow-icon.svg" alt=""  *ngIf="testReport?.testSubjects?.length > 1">
                            <div>
                                <h3 class="UNFAPP-icnhdng" *ngIf="testReport?.testSubjects?.length > 1">Scope of improvement</h3>
                                <h3 class="UNFAPP-icnhdng" *ngIf="bestSubjectChapters?.chapters?.length  > 1  && testReport?.testSubjects?.length == 1 && testReport?.bestChapter">Best chapter </h3>
                                <h4 class="UNFAPP-cunt elipssis" title="{{testReport?.scopeOfImprovement}}" *ngIf="testReport?.testSubjects?.length > 1">{{testReport?.scopeOfImprovement}}</h4>
                                <h4 class="UNFAPP-cunt elipssis" title="{{testReport?.bestChapter  }}" *ngIf="enableBestSubjectChanges ? bestSubjectChapters?.chapters?.length  > 1 && testReport?.testSubjects?.length == 1 && testReport?.bestChapter : bestSubjectChapters?.chapters?.length  > 1 && testReport?.testSubjects?.length == 1">{{testReport?.bestChapter  }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row equal-height-row" *ngIf="!showEqualiser">
            <div class="col-md-6">
                <div class="UNFAPP-score-whitetbx subject-wise">
                    <h3 class="scrbx-hdng">Subjectwise Score</h3>
                    <div class="row">
                        <div class="col-md-4"  *ngFor="let subject of testReport?.testSubjects;let i=index;">
                            <div class="UNFAPP-scr-chrtbx">
                                <ng-container>
                                    <div class="UNFAPP-scr-chrtarea">
                                        <app-doughnutchart *ngIf="i==0" [colors]="['#FFAD7A', '#e5e9ec']" [labels]="['TotalScore','OutOfScore']" [data]="[(subject?.totalScore<0)?0:subject?.totalScore,(subject?.outOfScore<0)?0:subject?.outOfScore]" ></app-doughnutchart>
                                        <app-doughnutchart *ngIf="i%2==1" [colors]="['#DB576F', '#e5e9ec']" [labels]="['TotalScore','OutOfScore']" [data]="[(subject?.totalScore<0)?0:subject?.totalScore,(subject?.outOfScore<0)?0:subject?.outOfScore]" ></app-doughnutchart>
                                        <app-doughnutchart *ngIf="i%2==0 && i!=0" [colors]="['#8EC478', '#e5e9ec']" [labels]="['TotalScore','OutOfScore']" [data]="[(subject?.totalScore<0)?0:subject?.totalScore,(subject?.outOfScore<0)?0:subject?.outOfScore]" ></app-doughnutchart>

                                    </div>
                                    <div class="UNFAPP-scr-infobx">
                                        <h2 class="scr-info-titl">  {{subject?.subjectName}}</h2>
                                        <div class="scr-info-cunt">
                                            {{subject?.totalScore}}<span class="scr-light-txt">/{{subject?.outOfScore}}</span>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <!-- <div class="col-md-4">
                            <div class="UNFAPP-scr-chrtbx">
                                <div class="UNFAPP-scr-chrtarea">
                                    <img src="assets/img/test-report/pie-chart-2.svg" alt="" />
                                </div>
                                <div class="UNFAPP-scr-infobx">
                                    <h2 class="scr-info-titl">Chemistry</h2>
                                    <div class="scr-info-cunt">
                                        90<span class="scr-light-txt">/180</span>
                                    </div>
                                </div>
                            </div>
                        </div>  -->
                        <!-- <div class="col-md-4">
                            <div class="UNFAPP-scr-chrtbx">
                                <div class="UNFAPP-scr-chrtarea">
                                    <img src="assets/img/test-report/pie-chart-3.svg" alt="" />
                                </div>
                                <div class="UNFAPP-scr-infobx">
                                    <h2 class="scr-info-titl">Biology</h2>
                                    <div class="scr-info-cunt">
                                        300<span class="scr-light-txt">/360</span>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="UNFAPP-score-whitetbx crt-incrt-chrtbx">
                    <div class="row">

                        <div class="col-md-5">
                            <div class="UNFAPP-chrtarea">
                                <app-doughnutchart *ngIf="showCharts" [colors]="['#6CD5B1', '#ff8c8c', '#e5e9ec']" [labels]="['Correct','In-Correct','Not-Attempted']" [data]="[(chartsDatas.correctAnswer) < 0 ? 0: chartsDatas.correctAnswer, (chartsDatas.incorrectAnswer) < 0 ? 0: chartsDatas.incorrectAnswer, (chartsDatas.unAttemptedQuestions) < 0 ? 0: chartsDatas.unAttemptedQuestions]"></app-doughnutchart>
                            </div>
                        </div>
                        <div class="col-md-7">
                            <ul class="chrt-infolist">
                                <li>
                                    <div class="UNFAPP-scr-infobx lstview">
                                        <h2 class="scr-info-titl"><span class="crt-dot green"></span>Correct</h2>
                                        <div class="scr-info-cunt">
                                            {{testReport.correctAnswer}}<span class="scr-light-txt">/{{testReport.totalQuestions}}</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="UNFAPP-scr-infobx lstview">
                                        <h2 class="scr-info-titl"><span class="crt-dot red"></span>Incorrect</h2>
                                        <div class="scr-info-cunt">
                                            {{testReport.incorrectAnswer}}<span class="scr-light-txt">/{{testReport.totalQuestions}}</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="UNFAPP-scr-infobx lstview">
                                        <h2 class="scr-info-titl"><span class="crt-dot"></span>Not-attempted</h2>
                                        <div class="scr-info-cunt">
                                            {{testReport.unAttemptedQuestions}}<span class="scr-light-txt">/{{testReport.totalQuestions}}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="QuestionsData?.questions">         
            <div class="col-md-12" *ngIf="showEqualiser">
                <h3 class="UNFAPP-tstreprt-sctn-hdng"  *ngIf="testReport.testSubjects?.length > 1 && (testReport?.bestSubject || testReport?.scopeOfImprovement)">Subject Performance</h3>
                <div class="UNFAPP-score-whitetbx UNFAPP-equalizer-box data-box UNFAPP-subjct-prfrmnce-box" *ngIf="testReport.testSubjects?.length > 1 &&(testReport?.bestSubject || testReport?.scopeOfImprovement)">
                    <div class="row justify-content-between">
                        <div class="col-md-6" *ngIf="enableBestSubjectChanges ? testReport?.bestSubject : true">
                            <div class="UNFAPP-subjct-data">
                                <img src="assets/img/best-chapter-yellow-icon.svg" class="icon" />
                                <span>Best Subject</span>
                                <label>{{testReport?.bestSubject}}</label>
                            </div>
                        </div>
                        <div class="col-md-6" *ngIf="enableBestSubjectChanges ? testReport?.scopeOfImprovement : true">
                            <div class="UNFAPP-subjct-data">
                                <img src="assets/img/emoji-sad-yellow-icon.svg" class="icon" />
                                <span>Scope of improvement</span>
                                <label>{{testReport?.scopeOfImprovement}}</label>
                            </div>
                        </div>
                        
                
                    </div>
                </div>


                <!-- <h3 class="UNFAPP-tstreprt-sctn-hdng topgap">Subject-wise Score</h3> -->
                <div class="UNFAPP-score-whitetbx subject-wise" *ngIf="QuestionsData?.questions?.subjects" [ngClass]="{'jeeadvance':(testResultUtility?.targetExam == 'JEEADVANCED'&& !testResultUtility.overallpaperSelected ) } ">
                    <h3 class="scrbx-hdng">Subjectwise Score</h3>
                    <app-subjectquestionlabel [subjects]="QuestionsData?.questions?.subjects" [testReport]="testReport" [testResultUtility]="testResultUtility" [viewSolutionAvailableTimebound]="viewSolutionAvailableTimebound" [overallpaperResult]="testResultUtility.overallpaperResult"></app-subjectquestionlabel>
                </div>
            </div>
            <div class="col-12"  *ngIf="showEqualiser">
                <div class="UNFAPP-score-whitetbx">
                    <div class="row">
                        <div class="col-xl-3 col-lg-3 col-md-6 col-12">
                            <div class="UNFAPP-score-with-type">
                                <span class="qube correct"></span>: Correct Answer
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-6 col-12">
                            <div class="UNFAPP-score-with-type">
                                <span class="qube incorrect"></span>: Incorrect Answer
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-6 col-12">
                            <div class="UNFAPP-score-with-type">
                                <span class="qube unattempted"></span>: Unattempted
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-6 col-12">
                            <div class="UNFAPP-score-with-type">
                                <span class="qube markedreview"></span>: Marked for review
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row" *ngIf="showEqualiser">
            <div class="col-md-12">
                <h3 class="UNFAPP-tstreprt-sctn-hdng mt-4">Chapter Insight</h3>
                <app-chapterinsight *ngIf="QuestionsData?.questions" [QuestionsData]="QuestionsData"  [viewSolutionAvailableTimebound] ="viewSolutionAvailableTimebound"[examRanges]="examRanges"
                    [testReport]="testReport"></app-chapterinsight>
            </div>
        </div>
        <div class="row" *ngIf="!showEqualiser">
            <div class="col-md-12">
                <h3 class="UNFAPP-tstreprt-sctn-hdng topgap">Subject-wise breakdown</h3>
            </div>
        </div>
        <div class="row" *ngIf="!showEqualiser">
            <div class="col-md-12">
                <div>
                    <mat-tab-group class="UNFAPP-tstrpt-tab-sectn" (selectedTabChange)="onSubjectTabChange($event)">
                        <mat-tab *ngFor="let subjectData of testReport.testSubjects">
                            <ng-template mat-tab-label>
                                <img class="tstrpt-tab-icon" src="assets/img/subject-icons/{{subjectData?.subjectName?.replace(' ','') | lowercase }}-icon.svg" alt="" style="width: 25px;"/>
                                {{subjectData.subjectName}}
                                <!-- <img class="tstrpt-tab-icon" *ngIf="subjectData.subjectName == 'PHYSICS'" src="assets/img/physics-solid-icon.svg" alt="" />
                                <img class="tstrpt-tab-icon" *ngIf="subjectData.subjectName == 'CHEMISTRY'" src="assets/img/Chem-solid-icon.svg" alt="" />
                                <img class="tstrpt-tab-icon" *ngIf="subjectData.subjectName == 'MATHEMATICS'" src="assets/img/subject-icons/maths.png" alt="" />
                                <img class="tstrpt-tab-icon" *ngIf="subjectData.subjectName == 'BIOLOGY'" src="assets/img/subject-icons/biology-small-icon.svg" alt="" />
                                <img class="tstrpt-tab-icon" *ngIf="subjectData.subjectName == 'BOTANY'" src="assets/img/subject-icons/biology-new-icon.svg" alt="" />
                                <img class="tstrpt-tab-icon" *ngIf="subjectData.subjectName == 'ZOOLOGY'" src="assets/img/subject-icons/zoology-small-icon.svg" alt="" /> -->


                            </ng-template>
                            <div class="UNFAPP-tstrpt-fltr-area" *ngIf="subjectData?.sectionExists">
                                <div class="fltr-drdp-bx">
                                    <div class="fltr-drdp-slctd-sctn">{{showSectionWiseReport ? selectedSectionToShow : 'ALL SECTIONS'}}<i class="fa fa-caret-down" aria-hidden="true"></i></div>
                                    <div class="fltr-drdplst-area leftalign">
                                        <ul class="fltr-course-list">
                                            <li>
                                                <label>
                                                    <input type="checkbox" [checked]="!showSectionWiseReport" (change)="selectedSection('all-section', null)" />
                                                    <span>ALL SECTIONS</span>
                                                </label>
                                            </li>
                                            <li *ngFor="let section of subjectData?.sections | keyvalue; index as k">
                                                <label>
                                                    <input type="checkbox" [checked]="selectesSectionInd == k" (change)="selectedSection(subjectData.subjectName, k)"/>
                                                    <span>SECTION {{k+1}}</span>
                                                </label>
                                            </li>
                                            <!-- <li>
                                                <label>
                                                    <input type="checkbox" (change)="selectedSection(subjectData.subjectName, 'SECTION2')"/>
                                                    <span>{{subjectData?.SECTION2}}</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label>
                                                    <input type="checkbox" (change)="selectedSection(subjectData.subjectName, 'SECTION3')"/>
                                                    <span>{{subjectData?.SECTION3}}</span>
                                                </label>
                                            </li> -->
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <ng-container *ngIf="!showSectionWiseReport">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="UNFAPP-score-whitetbx time-lstbox">
                                             <div class="UNFAPP-scrtmr-lstbx">
                                                 <div class="UNFAPP-scrtmr-col">
                                                     <div class="UNFAPP-scrtmr-blck">
                                                        <div class="UNFAPP-statbx-icon-info mob-vew">
                                                            <img src="assets/img/yellow-clock-md-icon.svg" alt="" />
                                                            <div>
                                                                <h3 class="UNFAPP-icnhdng">
                                                                    Total Time taken
                                                                </h3>
                                                                <h4 class="UNFAPP-cunt UNFAPP-elips">{{getTimeDetails(subjectData.totalVisitedTime)}}</h4>
                                                            </div>
                                                        </div>
                                                     </div>
                                                     <div class="UNFAPP-scrtmr-blck">
                                                        <div class="UNFAPP-statbx-icon-info mob-vew">
                                                            <img src="assets/img/accuracy-yellow-icon.svg" alt="" />
                                                            <div>
                                                                <h3 class="UNFAPP-icnhdng">
                                                                    Accuracy
                                                                </h3>
                                                                <h4 class="UNFAPP-cunt UNFAPP-elips">{{((isnan(testReport?.accuracy) || !testReport?.accuracy)?0:subjectData.accuracy) | number : '1.0-2'}}%</h4>
                                                            </div>
                                                        </div>
                                                     </div>
                                                 </div>
                                                 <div class="UNFAPP-scrtmr-col">
                                                     <div class="UNFAPP-scrtmr-blck">
                                                        <div class="UNFAPP-statbx-icon-info mob-vew">
                                                            <img src="assets/img/yellow-clock-md-icon.svg" alt="" />
                                                            <div>
                                                                <h3 class="UNFAPP-icnhdng">
                                                                    <span class="UNFAPP-cmn-mob-hide">Avg. time per question</span>
                                                                    <span class="UNFAPP-cmn-desk-hide">Avg. time / question</span>
                                                                </h3>
                                                                <h4 class="UNFAPP-cunt UNFAPP-elips">{{ getTimeDetails(subjectData.totalVisitedTime/subjectData.totalVisitedQuestions) }}</h4>
                                                            </div>
                                                        </div>
                                                     </div>
                                                     <div class="UNFAPP-scrtmr-blck">
                                                        <div class="UNFAPP-statbx-icon-info mob-vew">
                                                            <img src="assets/img/accuracy-yellow-icon.svg" alt="" />
                                                            <div>
                                                                <h3 class="UNFAPP-icnhdng">
                                                                    Score
                                                                </h3>
                                                                <h4 class="UNFAPP-cunt UNFAPP-elips">{{subjectData.totalScore}}/{{subjectData.outOfScore}}</h4>
                                                            </div>
                                                        </div>
                                                     </div>
                                                 </div>
                                             </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="UNFAPP-score-whitetbx crt-incrt-chrtbx smview">
                                            <div class="row">
                                                <div class="col-md-4 col-4">
                                                    <div class="UNFAPP-chrtarea">
                                                        <!-- <img src="assets/img/test-report/pie-chart-4.svg" alt="" class="chrt-img" /> -->
                                    <app-doughnutchart [colors]="['#6CD5B1', '#ff8c8c', '#e5e9ec']" [labels]="['Correct','In-Correct','Not-Attempted']" [data]="[subjectData.totalCorrectQuestions,subjectData.totalInCorrectQuestions,subjectData.totalUnAttemptedQuestions]"></app-doughnutchart>
    
                                                    </div>
                                                </div>
                                                <div class="col-md-8 col-8">
                                                    <ul class="chrt-infolist">
                                                        <li>
                                                            <div class="UNFAPP-scr-infobx lstview">
                                                                <h2 class="scr-info-titl"><span class="crt-dot green"></span>Correct</h2>
                                                                <div class="scr-info-cunt">
                                                                    {{subjectData.totalCorrectQuestions}}<span class="scr-light-txt">/{{subjectData.totalQuestions}}</span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="UNFAPP-scr-infobx lstview">
                                                                <h2 class="scr-info-titl"><span class="crt-dot red"></span>Incorrect</h2>
                                                                <div class="scr-info-cunt">
                                                                    {{subjectData.totalInCorrectQuestions}}<span class="scr-light-txt">/{{subjectData.totalQuestions}}</span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="UNFAPP-scr-infobx lstview">
                                                                <h2 class="scr-info-titl"><span class="crt-dot"></span>Not-attempted</h2>
                                                                <div class="scr-info-cunt">
                                                                    {{subjectData.totalUnAttemptedQuestions}}<span class="scr-light-txt">/{{subjectData.totalQuestions}}</span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row" *ngIf="(examinfo.examtype !=='SCOREAWAT' && (examinfo?.examtype !== 'SCOREMOCKTEST' && examinfo?.examtype !== 'SCORE23MOCKTEST')) else scoreReport" >
                                    <div class="col-md-12">
                                        <div class="UNFAPP-score-whitetbx UNFAPP-chptr-fullbox" *ngIf="subjectData.bestChapters && subjectData.bestChapters.length > 0 &&  subjectData?.chapters.length > 1 ">
                                            <h3 class="scrbx-hdng">Strong Chapters</h3>
    
                                            <div class="row mob-scroll-row">
                                                <div class="col-md-12 col-10" *ngFor="let bestChapters of subjectData.bestChapters;let i = index">
                                                    <div class="UNFAPP-chptr-rwbx" *ngIf="i<3">
                                                        <div class="UNFAPP-chptr-nmcol">{{bestChapters.chapterName}}</div>
                                                        <div class="UNFAPP-chptr-rgt">
                                                            <div class="UNFAPP-chptr-rngsldr-area">
                                                                <h3 class="chptr-numtxt">{{bestChapters.correctQuetions}}/{{bestChapters.totalAttemptedQuestions}}<small>Correct</small></h3>
                                                                <div class="chprt-sld-box">
                                                                    <!-- <progress id="file" value="bestChapters.correctQuetions" max="bestChapters.totalQuestions"></progress> -->
                                                                    <mat-progress-bar class="UNFAPP-chptr-prgbar" mode="determinate" [value]="(bestChapters.correctQuetions/bestChapters.totalAttemptedQuestions)*100"></mat-progress-bar>
                                                                </div>
                                                            </div>
                                                            <h3 class="chptr-numtxt">{{(bestChapters.totalVisitedTime/bestChapters.totalAttemptedQuestions) | number: "1.2-2" }}s<small>Avg. time/question</small></h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                       
                                        <div class="UNFAPP-score-whitetbx UNFAPP-chptr-fullbox" *ngIf="subjectData.worstChapters && subjectData.worstChapters.length > 0 &&  subjectData?.chapters.length > 1 ">
                                            <h3 class="scrbx-hdng">Chapters with Scope of Improvement</h3>
                                            <div class="row mob-scroll-row">
                                                <div class="col-md-12 col-10" *ngFor="let worstChapters of subjectData.worstChapters;let i = index">
                                                    <div class="UNFAPP-chptr-rwbx" *ngIf="i<3">
                                                        <div class="UNFAPP-chptr-nmcol">{{worstChapters.chapterName}}</div>
                                                        <div class="UNFAPP-chptr-rgt">
                                                            <div class="UNFAPP-chptr-rngsldr-area">
                                                                <h3 class="chptr-numtxt">{{worstChapters.correctQuetions}}/{{worstChapters.totalAttemptedQuestions}}<small>Correct</small></h3>
                                                                <div class="chprt-sld-box">
                                                                    <mat-progress-bar class="UNFAPP-chptr-prgbar" mode="determinate" [value]="(worstChapters.correctQuetions/worstChapters.totalQuestions)*100"></mat-progress-bar>
                                                                </div>
                                                            </div>
                                                            <h3 class="chptr-numtxt">{{(worstChapters.totalVisitedTime/worstChapters.totalAttemptedQuestions) | number: "1.0-2"}}s<small>Avg. time/question</small></h3>
                                                        </div>
                                                    </div>
                                                </div>
    
                                            </div>
    
                                        </div>
                                    </div>
                                </div>
                                <ng-template class="row" #scoreReport>
                                    <ng-container  *ngTemplateOutlet="chapterscoreReport; context: { $implicit: subjectData?.chapters}"></ng-container> 
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="showSectionWiseReport">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="UNFAPP-score-whitetbx time-lstbox">
                                             <div class="UNFAPP-scrtmr-lstbx">
                                                 <div class="UNFAPP-scrtmr-col">
                                                     <div class="UNFAPP-scrtmr-blck">
                                                        <div class="UNFAPP-statbx-icon-info mob-vew">
                                                            <img src="assets/img/yellow-clock-md-icon.svg" alt="" />
                                                            <div>
                                                                <h3 class="UNFAPP-icnhdng">
                                                                    Total Time taken
                                                                </h3>
                                                                <h4 class="UNFAPP-cunt UNFAPP-elips">{{getTimeDetails(sectionData.totalVisitedTime)}}</h4>
                                                            </div>
                                                        </div>
                                                     </div>
                                                     <div class="UNFAPP-scrtmr-blck">
                                                        <div class="UNFAPP-statbx-icon-info mob-vew">
                                                            <img src="assets/img/accuracy-yellow-icon.svg" alt="" />
                                                            <div>
                                                                <h3 class="UNFAPP-icnhdng">
                                                                    Accuracy
                                                                </h3>
                                                                <h4 class="UNFAPP-cunt UNFAPP-elips">{{((isnan(testReport?.accuracy) || !testReport?.accuracy)?0:sectionData.accuracy) | number : '1.0-2'}}%</h4>
                                                            </div>
                                                        </div>
                                                     </div>
                                                 </div>
                                                 <div class="UNFAPP-scrtmr-col">
                                                     <div class="UNFAPP-scrtmr-blck">
                                                        <div class="UNFAPP-statbx-icon-info mob-vew">
                                                            <img src="assets/img/yellow-clock-md-icon.svg" alt="" />
                                                            <div>
                                                                <h3 class="UNFAPP-icnhdng">
                                                                    <span class="UNFAPP-cmn-mob-hide">Avg. time per question</span>
                                                                    <span class="UNFAPP-cmn-desk-hide">Avg. time / question</span>
                                                                </h3>
                                                                <h4 class="UNFAPP-cunt UNFAPP-elips">{{ getTimeDetails(sectionData.totalVisitedTime/sectionData.totalVisitedQuestions) }}</h4>
                                                            </div>
                                                        </div>
                                                     </div>
                                                     <div class="UNFAPP-scrtmr-blck">
                                                        <div class="UNFAPP-statbx-icon-info mob-vew">
                                                            <img src="assets/img/accuracy-yellow-icon.svg" alt="" />
                                                            <div>
                                                                <h3 class="UNFAPP-icnhdng">
                                                                    Score
                                                                </h3>
                                                                <h4 class="UNFAPP-cunt UNFAPP-elips">{{sectionData.totalScore}}/{{sectionData.outOfScore}}</h4>
                                                            </div>
                                                        </div>
                                                     </div>
                                                 </div>
                                             </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="UNFAPP-score-whitetbx crt-incrt-chrtbx smview">
                                            <div class="row">
                                                <div class="col-md-4 col-4">
                                                    <div class="UNFAPP-chrtarea">
                                                        <!-- <img src="assets/img/test-report/pie-chart-4.svg" alt="" class="chrt-img" /> -->
                                                        <app-doughnutchart [colors]="['#6CD5B1', '#ff8c8c', '#e5e9ec']" [labels]="['Correct','In-Correct','Not-Attempted']" [data]="[sectionData.totalCorrectQuestions,sectionData.totalInCorrectQuestions,sectionData.totalUnAttemptedQuestions]"></app-doughnutchart>
    
                                                    </div>
                                                </div>
                                                <div class="col-md-8 col-8">
                                                    <ul class="chrt-infolist">
                                                        <li>
                                                            <div class="UNFAPP-scr-infobx lstview">
                                                                <h2 class="scr-info-titl"><span class="crt-dot green"></span>Correct</h2>
                                                                <div class="scr-info-cunt">
                                                                    {{sectionData.totalCorrectQuestions}}<span class="scr-light-txt">/{{sectionData.totalQuestions}}</span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="UNFAPP-scr-infobx lstview">
                                                                <h2 class="scr-info-titl"><span class="crt-dot red"></span>Incorrect</h2>
                                                                <div class="scr-info-cunt">
                                                                    {{sectionData.totalInCorrectQuestions}}<span class="scr-light-txt">/{{sectionData.totalQuestions}}</span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="UNFAPP-scr-infobx lstview">
                                                                <h2 class="scr-info-titl"><span class="crt-dot"></span>Not-attempted</h2>
                                                                <div class="scr-info-cunt">
                                                                    {{sectionData.totalUnAttemptedQuestions}}<span class="scr-light-txt">/{{sectionData.totalQuestions}}</span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row"  *ngIf="(examinfo.examtype !=='SCOREAWAT' && ( examinfo?.examtype !== 'SCOREMOCKTEST'&& examinfo?.examtype !== 'SCORE23MOCKTEST')); else scoreReport">
                                    <div class="col-md-12">
                                        <div class="UNFAPP-score-whitetbx UNFAPP-chptr-fullbox" *ngIf="sectionData.bestChapters && sectionData.bestChapters.length > 0 &&   sectionData?.chapters.length > 1 ">
                                            <h3 class="scrbx-hdng">Strong Chapters</h3>
    
                                            <div class="row mob-scroll-row">
                                                <div class="col-md-12 col-10" *ngFor="let bestChapters of sectionData.bestChapters;let i = index">
                                                    <div class="UNFAPP-chptr-rwbx" *ngIf="i<3">
                                                        <div class="UNFAPP-chptr-nmcol">{{bestChapters.chapterName}}</div>
                                                        <div class="UNFAPP-chptr-rgt">
                                                            <div class="UNFAPP-chptr-rngsldr-area">
                                                                <h3 class="chptr-numtxt">{{bestChapters.correctQuetions}}/{{bestChapters.totalAttemptedQuestions}}<small>Correct</small></h3>
                                                                <div class="chprt-sld-box">
                                                                    <!-- <progress id="file" value="bestChapters.correctQuetions" max="bestChapters.totalQuestions"></progress> -->
                                                                    <mat-progress-bar class="UNFAPP-chptr-prgbar" mode="determinate" [value]="(bestChapters.correctQuetions/bestChapters.totalAttemptedQuestions)*100"></mat-progress-bar>
                                                                </div>
                                                            </div>
                                                            <h3 class="chptr-numtxt">{{(bestChapters.totalVisitedTime/bestChapters.totalAttemptedQuestions) | number: "1.2-2" }}s<small>Avg. time/question</small></h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="UNFAPP-score-whitetbx UNFAPP-chptr-fullbox" *ngIf="sectionData.worstChapters && sectionData.worstChapters.length > 0 &&  sectionData?.chapters.length > 1 ">
                                            <h3 class="scrbx-hdng">Chapters with Scope of Improvement</h3>
                                            <div class="row mob-scroll-row">
                                                <div class="col-md-12 col-10" *ngFor="let worstChapters of sectionData.worstChapters;let i = index">
                                                    <div class="UNFAPP-chptr-rwbx" *ngIf="i<3">
                                                        <div class="UNFAPP-chptr-nmcol">{{worstChapters.chapterName}}</div>
                                                        <div class="UNFAPP-chptr-rgt">
                                                            <div class="UNFAPP-chptr-rngsldr-area">
                                                                <h3 class="chptr-numtxt">{{worstChapters.correctQuetions}}/{{worstChapters.totalAttemptedQuestions}}<small>Correct</small></h3>
                                                                <div class="chprt-sld-box">
                                                                    <mat-progress-bar class="UNFAPP-chptr-prgbar" mode="determinate" [value]="(worstChapters.correctQuetions/worstChapters.totalAttemptedQuestions)*100"></mat-progress-bar>
                                                                </div>
                                                            </div>
                                                            <h3 class="chptr-numtxt">{{(worstChapters.totalVisitedTime/worstChapters.totalAttemptedQuestions) | number: "1.0-2"}}s<small>Avg. time/question</small></h3>
                                                        </div>
                                                    </div>
                                                </div>
    
                                            </div>
    
                                        </div>
                                    </div>
                                </div>
                                <ng-template class="row" #scoreReport>
                                    <ng-container  *ngTemplateOutlet="chapterscoreReport; context: { $implicit: sectionData?.chapters}"></ng-container> 
                                </ng-template>
                            </ng-container>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>

        <!-- <div class="row">
            <div class="col-md-12">
                <h3 class="UNFAPP-tstprt-rcmd-lnrhdng">Recommendations to Learn Weak Chapters</h3>
            </div>
        </div> -->


        <!-- <div class="row">
            <div class="col-md-12">
                <div class="UNFAPP-wtchrecomad-sctn">
                    <div class="UNFAPP-scn-hdng-area">
                        <h3 class="UNFAPP-hdng">Watch These</h3>
                    </div>
                    <div class="row mob-scroll-row">
                        <div class="col-md-4 col-10">
                            <div class="UNFAPP-wtchths-bx">
                                <div class="UNFAPP-wtchths-imgbx">
                                    <button class="UNFAPP-wtchths-plyicn">
                                        <img class="plyicn-img" src="assets/img/dashboard/play-icon.svg" alt="" />
                                    </button>
                                    <img class="UNFAPP-wtchths-img" src="assets/img/dashboard/master-class-pic-2.jpg" alt="" />
                                    <div class="UNFAPP-vdprgrsbar"><span></span></div>
                                </div>
                                <div class="UNFAPP-wtchths-cntarea">
                                    <h3 class="UNFAPP-wtchths-title">SHM</h3>
                                    <h4 class="UNFAPP-wtchths-subtitle">20 mins</h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-10">
                            <div class="UNFAPP-wtchths-bx">
                                <div class="UNFAPP-wtchths-imgbx">
                                    <button class="UNFAPP-wtchths-plyicn">
                                        <img class="plyicn-img" src="assets/img/dashboard/play-icon.svg" alt="" />
                                    </button>
                                    <img class="UNFAPP-wtchths-img" src="assets/img/new-liveclass/teacher-03.jpg" alt="" />
                                    <div class="UNFAPP-vdprgrsbar"><span></span></div>
                                </div>
                                <div class="UNFAPP-wtchths-cntarea">
                                    <h3 class="UNFAPP-wtchths-title">Work</h3>
                                    <h4 class="UNFAPP-wtchths-subtitle">20 mins</h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-10">
                            <div class="UNFAPP-wtchths-bx">
                                <div class="UNFAPP-wtchths-imgbx">
                                    <button class="UNFAPP-wtchths-plyicn">
                                        <img class="plyicn-img" src="assets/img/dashboard/play-icon.svg" alt="" />
                                    </button>
                                    <img class="UNFAPP-wtchths-img" src="assets/img/new-liveclass/teacher-01.jpg" alt="" />
                                    <div class="UNFAPP-vdprgrsbar"><span></span></div>
                                </div>
                                <div class="UNFAPP-wtchths-cntarea">
                                    <h3 class="UNFAPP-wtchths-title">Potential Energy</h3>
                                    <h4 class="UNFAPP-wtchths-subtitle">20 mins</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- <div class="row">
            <div class="col-md-12">
                <div class="UNFAPP-wtchrecomad-sctn">
                    <div class="UNFAPP-scn-hdng-area">
                        <h3 class="UNFAPP-hdng">Read These </h3>
                    </div>
                    <ol class="row  mob-scroll-row readthis-lst">
                        <li class="col-lg-2 col-md-4 col-5">
                            <div class="UNFAPP-ylw-rdtsbox">
                                <div class="UNFAPP-ylw-titlarea">
                                    <h3 class="h3-ylw-titl">Kinetic Energy</h3>
                                    <h4 class="h4-ylw-titl"><span>4 cards</span> <i class="fa fa-caret-right"></i></h4>
                                </div>
                            </div>
                        </li>
                        <li class="col-lg-2 col-md-4 col-5">
                            <div class="UNFAPP-ylw-rdtsbox">
                                <div class="UNFAPP-ylw-titlarea">
                                    <h3 class="h3-ylw-titl">Power</h3>
                                    <h4 class="h4-ylw-titl"><span>4 cards</span> <i class="fa fa-caret-right"></i></h4>
                                </div>
                            </div>
                        </li>
                        <li class="col-lg-2 col-md-4 col-5">
                            <div class="UNFAPP-ylw-rdtsbox">
                                <div class="UNFAPP-ylw-titlarea">
                                    <h3 class="h3-ylw-titl">Pulleys</h3>
                                    <h4 class="h4-ylw-titl"><span>4 cards</span> <i class="fa fa-caret-right"></i></h4>
                                </div>
                            </div>
                        </li>
                        <li class="col-lg-2 col-md-4 col-5">
                            <div class="UNFAPP-ylw-rdtsbox">
                                <div class="UNFAPP-ylw-titlarea">
                                    <h3 class="h3-ylw-titl">Potential Energy</h3>
                                    <h4 class="h4-ylw-titl"><span>4 cards</span> <i class="fa fa-caret-right"></i></h4>
                                </div>
                            </div>
                        </li>
                        <li class="col-lg-2 col-md-4 col-5">
                            <div class="UNFAPP-ylw-rdtsbox">
                                <div class="UNFAPP-ylw-titlarea">
                                    <h3 class="h3-ylw-titl">Work</h3>
                                    <h4 class="h4-ylw-titl"><span>4 cards</span> <i class="fa fa-caret-right"></i></h4>
                                </div>
                            </div>
                        </li>

                    </ol>
                </div>
            </div>
        </div> -->

        <!-- <div class="row">
            <div class="col-md-12">
                <div class="UNFAPP-wtchrecomad-sctn">
                    <div class="UNFAPP-scn-hdng-area">
                        <h3 class="UNFAPP-hdng">Live Classes</h3>
                    </div>
                    <div class="row UNFAPP-lvcls-mob-rw-scrll">
                        <div class="col-lg-4 col-md-8 col-11">
                            <div class="UNFAPP-lvmtrcls-bx">
                                <div class="UNFAPP-lvmtrcls-imgbx">
                                    <img class="lvmtrcls-imgbx-img" src="assets/img/dashboard/master-class-pic-1.jpg" alt="" />
                                </div>
                                <div class="UNFAPP-lvmtrcls-cntarea">
                                    <div class="UNFAPP-mstr-subjct">
                                        <img class="mstr-subjct-icon" src="assets/img/subject-icons/physics-new-icon.svg" alt="" />
                                        <span>Physics</span>
                                    </div>
                                    <h3 class="UNFAPP-lvmtrcls-title">Magnetic Effects of Electric Current</h3>
                                    <h4 class="UNFAPP-lvmtrcls-subtitle">By Shubham Mehra</h4>
                                    <div class="UNFAPP-lvmtrcls-actn-area">
                                        <button class="UNFAPP-lvmtrcls-jnbtn">REWATCH</button>
                                        <button type="button" class="UNFAPP-lvmtrcls-dtlbtn">DETAILS <i class="fa fa-caret-up" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-8 col-11">
                            <div class="UNFAPP-lvmtrcls-bx">
                                <div class="UNFAPP-lvmtrcls-imgbx">
                                    <span class="livetag tomorrow">STARTS TOMORROW</span>
                                    <img class="lvmtrcls-imgbx-img" src="assets/img/new-liveclass/teacher-03.jpg" alt="" />
                                </div>
                                <div class="UNFAPP-lvmtrcls-cntarea">
                                    <div class="UNFAPP-mstr-subjct">
                                        <img class="mstr-subjct-icon" src="assets/img/subject-icons/chemistry-new-icon.svg" alt="" />
                                        <span>Chemistry</span>
                                    </div>
                                    <h3 class="UNFAPP-lvmtrcls-title" style="margin-bottom: 24px;">p-Block</h3>
                                    <h4 class="UNFAPP-lvmtrcls-subtitle">By Shubham Mehra</h4>
                                    <div class="UNFAPP-lvmtrcls-actn-area">
                                        <button class="UNFAPP-lvmtrcls-jnbtn">REGISTER</button>
                                        <button type="button" class="UNFAPP-lvmtrcls-dtlbtn">DETAILS <i class="fa fa-caret-up" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->


    <!-- Score floating gift icon starts-->
        <!-- <button class="SC-GFTCPN-fl-gfticon" *ngIf="checkPreConditionsForGiftsToDisplayGiftIcon()" (click)="dialogRefGifts=undefined;scGiftCoupn()">
            <img src="assets/img/score-gifticon-flot.svg" alt="">
        </button> -->
        <!-- floating gift icon ends-->

        <!-- Nonscore floating gift icon starts-->
        <button class="SC-GFTCPN-fl-gfticon" *ngIf="checkPreConditionsForGiftsToDisplayGiftIcon() && examinfo?.examtype !== 'SCOREMOCKTEST'"   (click)="dialogRefGifts=undefined;scGiftCoupn()">
            <!-- <img src="assets/img/nonscore-gifticon-flot.svg" alt=""> -->
            <img src="assets/img/gifticon.png" alt="">
        </button>
        <!-- floating gift icon ends-->
        

    </div>
</div>
<ng-template #chapterscoreReport let-chapterdata > 
<div class="STU-sctn-area">
    <h3 class="UNFAPP-tstreprt-sctn-hdng-sm d-hide mb-3">Chapters</h3>
    <div class="STU-subject-border-box">
        <table class="STU-subject-table">
            <tr class="table-header-row">
                <th class="title-col">Chapters</th>
                <th>Total Qs</th>
                <th>Correct/Wrong/Unattempted</th>
                <th>Marks Achieved</th>
                <th>Accuracy</th>
                <th>Avg. Time/Q </th>
            </tr>
            <tr #mob_accro *ngFor="let chapter of chapterdata; let i = index;">
                <td data-label="Chapters" class="title-col"><div class="chapter-ellipsis">{{chapter?.chapterName}}</div>
                    <small *ngIf="chapter?.accuracy >= 80" class="chrmsg full-width green-text">Keep it up!</small>
                    <small *ngIf="chapter?.accuracy < 80" class="chrmsg full-width red-text">Needs Improvement</small>
                </td>
                <td class="totalQ-col" data-label="Qs">{{chapter?.totalQuestions}}</td>
                <td class="correct-col" data-label="Correct/Wrong/Unattempted">
                    <div class="STU-subject-correct-block">
                        <div class="correct-block">
                            <span class="correct-block-icn"><img src="assets/img/green-bg-tick.svg" /></span>
                            <span class="correct-number">
                                {{chapter?.correctQuetions | number : '2.0'}}
                                <!-- {{chapter?.correctQuetions}} -->
                            </span>
                        </div>
                        <div class="correct-block">
                            <span class="correct-block-icn"><img src="assets/img/red-bg-cross.svg" /></span>
                            <span class="correct-number">{{chapter?.incorrectQuetions | number : '2.0'}}</span>
                        </div>
                        <div class="correct-block">
                            <span class="correct-block-icn gray"></span>
                            <span class="correct-number">{{chapter?.totalUnattempted | number : '2.0'}}</span>
                        </div>
                    </div>
                </td>
                <td class="achieved-col" data-label="Marks Achieved"><b>{{chapter?.totalScore | number : '2.0'}}</b> / {{chapter?.totalMarks | number : '2.0'}}</td>
                <td class="accuracy-col" data-label="Accuracy">
                    <ng-container *ngIf="chapter?.accuracy == 0"><span class="accuracy-number">NA</span></ng-container>
                    <ng-container *ngIf="chapter?.accuracy > 0">
                        <div class="accuracy-number"><span class="accuracy-elics">{{chapter?.accuracy ? chapter?.accuracy: '0'}}</span>%</div>
                    </ng-container>
                    <button class="expand-arrow" (click)="mob_accro.classList.toggle('opened-cols')"><img src="assets/img/btn-link-arrow-blue2.svg" /></button>
                </td>
                <td class="avgtime-col" data-label="Avg T/Q">
                    <ng-container *ngIf="chapter?.avgTime == 0">NA</ng-container>
                    <ng-container *ngIf="chapter?.avgTime > 0">{{chapter?.avgTime|timeconvert}}</ng-container>
                </td>
            </tr>

        </table>
    </div>


</div>
 

</ng-template>